import {connect} from "react-redux"
import {ColourwayData} from "../../../models/searchApi"
import State from "../../../models/state"
import isMadeToMeasure from "../../../utils/isMadeToMeasure"
import setFavouriteEnabled from "../../../utils/setFavouriteEnabled"
import {FAV_CATEGORY_EXCLUSION} from "../../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {colourways, category, type},
        },
        productSummary: {enableSingleLineTitle},
        template,
    } = state
    const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData
    const isMade2Measure = isMadeToMeasure(selectedColourway?.pt)
    const isPersonalised = !colourways[0]?.pt

    return {
        templating: template,
        enableSingleLineTitle,
        favouriteBtnEnabled:
            !isMade2Measure && !FAV_CATEGORY_EXCLUSION.includes(category)
                ? setFavouriteEnabled(type, isPersonalised)
                : false,
    }
}

export default connect(mapStateToProps)
